import { ChangeDetectionStrategy, Component, computed, inject, signal, viewChild } from '@angular/core';
import { UserService } from '@core/services';
import { toSignal } from '@angular/core/rxjs-interop';
import { PersonalizationService } from '@shared/services/personalization.service';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { Profile } from '@/features/administration/user-profile/types/profile';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { Popover, PopoverModule } from 'primeng/popover';

@Component({
  selector: 'cis-profile-switcher',
  imports: [BsDropdownModule, ButtonModule, PopoverModule],
  template: `
    @if (profiles()) {
      @if (profiles().length > 1) {
        @if (userProfiles(); as profile) {
          <p-button
            text
            size="small"
            class="flex align-items-center gap-2"
            [style]="{
              padding: '0',
            }"
            (click)="toggle($event)">
            <span pButtonLabel>{{ profile.name }}</span>
            <i pButtonIcon [class]="'pi ' + chevronIcon()"></i>
          </p-button>
        }
        <p-popover #op>
          <ng-template #content>
            <div id="profile-switcher-content" class="w-full h-full flex flex-column gap-2">
              @for (profile of profiles(); track profile.id) {
                <p-button fluid text size="small" styleClass="justify-content-start" (click)="setProfile(profile)">
                  @if (!profile.role.name.includes('superadmin')) {}
                  <span>{{ profile.name }}</span>
                </p-button>
              }
            </div>
          </ng-template>
        </p-popover>
      }
      @if (profiles().length < 2) {
        @if (userProfiles(); as profile) {
          <div class="cursor-auto">
            <span>{{ profile.name }}</span>
          </div>
        }
      }
    }
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileSwitcherComponent {
  private readonly userService = inject(UserService);
  private readonly personalizationService = inject(PersonalizationService);
  private readonly router = inject(Router);

  op = viewChild<Popover>('op');
  isOpen = signal(false);

  profiles = toSignal(this.userService.getCurrentUserProfiles(), {
    initialValue: [],
  });
  userProfiles = toSignal(this.personalizationService.profiles$);

  chevronIcon = computed(() => (this.isOpen() ? 'pi-chevron-up' : 'pi-chevron-down'));

  setProfile(profile: Profile) {
    this.personalizationService.setProfile(profile);
    window.location.reload();
  }

  toggle(event: Event) {
    event.stopPropagation();
    this.isOpen.update((prev) => !prev);
    this.op()?.toggle(event);
  }
}
